(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ls-footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ls-soil-temperature-chart"] && !Shopify.designMode) return;
  try {
    
(() => {
  const svg = document.querySelector('[data-soil-chart]');
  const empty = document.querySelector('[data-soil-chart-empty]');
  const tooltip = document.querySelector('[data-soil-chart-tooltip]');
  if (!svg) return;

  const ns = 'http://www.w3.org/2000/svg';
  const width = 900;
  const height = 340;
  const left = 72;
  const right = 28;
  const top = 24;
  const bottom = 52;

  const createText = (x, y, text, className, anchor = 'start') => {
    const node = document.createElementNS(ns, 'text');
    node.setAttribute('x', x);
    node.setAttribute('y', y);
    node.setAttribute('text-anchor', anchor);
    node.setAttribute('class', className);
    node.textContent = text;
    svg.append(node);
  };

  const formatDate = (date) => new Date(`${date}T12:00:00`).toLocaleDateString(undefined, { month: 'short', day: 'numeric' });

  const showTooltip = (event, item, pointX, pointY) => {
    if (!tooltip) return;
    const rect = svg.getBoundingClientRect();
    const scaleX = rect.width / width;
    const scaleY = rect.height / height;
    tooltip.textContent = `${formatDate(item.date)} · ${Math.round(item.value)}°F`;
    tooltip.style.left = `${pointX * scaleX}px`;
    tooltip.style.top = `${pointY * scaleY}px`;
    tooltip.hidden = false;
  };

  const hideTooltip = () => {
    if (tooltip) tooltip.hidden = true;
  };

  const draw = (series) => {
    if (!Array.isArray(series) || series.length < 2) return;

    empty.hidden = true;
    svg.replaceChildren();
    hideTooltip();

    const values = series.map((item) => Number(item.value));
    const rawMin = Math.min(...values);
    const rawMax = Math.max(...values);
    const min = Math.floor((rawMin - 2) / 5) * 5;
    const max = Math.ceil((rawMax + 2) / 5) * 5;
    const span = Math.max(5, max - min);
    const plotHeight = height - top - bottom;
    const plotWidth = width - left - right;
    const x = (index) => left + (index / (series.length - 1)) * plotWidth;
    const y = (value) => top + ((max - value) / span) * plotHeight;

    for (let temperature = max; temperature >= min; temperature -= 5) {
      const gridY = y(temperature);
      const line = document.createElementNS(ns, 'line');
      line.setAttribute('x1', left);
      line.setAttribute('x2', width - right);
      line.setAttribute('y1', gridY);
      line.setAttribute('y2', gridY);
      line.setAttribute('class', 'ls-soil-chart__grid');
      svg.append(line);
      createText(left - 12, gridY + 5, `${temperature}°F`, 'ls-soil-chart__axis-label', 'end');
    }

    const path = document.createElementNS(ns, 'path');
    path.setAttribute('d', series.map((item, index) => `${index ? 'L' : 'M'} ${x(index)} ${y(item.value)}`).join(' '));
    path.setAttribute('class', 'ls-soil-chart__line');
    svg.append(path);

    series.forEach((item, index) => {
      if (index % 7 === 0 || index === series.length - 1) {
        createText(x(index), height - 16, formatDate(item.date), 'ls-soil-chart__label', 'middle');
      }

      const hit = document.createElementNS(ns, 'circle');
      hit.setAttribute('cx', x(index));
      hit.setAttribute('cy', y(item.value));
      hit.setAttribute('r', 13);
      hit.setAttribute('class', 'ls-soil-chart__hit');
      hit.addEventListener('mouseenter', (event) => showTooltip(event, item, x(index), y(item.value)));
      hit.addEventListener('mouseleave', hideTooltip);
      hit.addEventListener('click', (event) => showTooltip(event, item, x(index), y(item.value)));
      svg.append(hit);
    });

    const lastIndex = series.length - 1;
    const last = series[lastIndex];
    const lastX = x(lastIndex);
    const lastY = y(last.value);
    const dot = document.createElementNS(ns, 'circle');
    dot.setAttribute('cx', lastX);
    dot.setAttribute('cy', lastY);
    dot.setAttribute('r', 6);
    dot.setAttribute('class', 'ls-soil-chart__dot');
    svg.append(dot);
    createText(lastX - 8, lastY - 14, `${Math.round(last.value)}°F`, 'ls-soil-chart__value-label', 'end');
  };

  window.addEventListener('ls:soil-data', (event) => draw(event.detail?.series));
  if (window.LSSoilData?.series) draw(window.LSSoilData.series);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ls-soil-temperature-lawn-selector"] && !Shopify.designMode) return;
  try {
    
(() => {
  const storageKey = 'ls-fit-finder-session-shared-v1';
  const sessionKey = 'ls-fit-finder-session-v1';
  const lifetime = 365 * 24 * 60 * 60;

  const read = () => {
    try {
      return JSON.parse(localStorage.getItem(storageKey) || '{}');
    } catch (error) {
      return {};
    }
  };

  const write = (session) => {
    const value = { ...session, updatedAt: Date.now() };
    const serialized = JSON.stringify(value);
    try { localStorage.setItem(storageKey, serialized); } catch (error) {}
    try { sessionStorage.setItem(sessionKey, serialized); } catch (error) {}
    try { document.cookie = `${sessionKey}=${encodeURIComponent(serialized)}; path=/; max-age=${lifetime}; SameSite=Lax`; } catch (error) {}
    return value;
  };

  const initialize = (root) => {
    if (!root || root.dataset.lawnSelectorReady === 'true') return;
    root.dataset.lawnSelectorReady = 'true';

    const cards = Array.from(root.querySelectorAll('[data-lawn-name]'));
    const selected = root.querySelector('[data-lawn-selected]');
    const selectedName = root.querySelector('[data-lawn-selected-name]');

    const render = (name) => {
      cards.forEach((card) => {
        const isSelected = card.dataset.lawnName === name;
        card.classList.toggle('is-selected', isSelected);
        card.setAttribute('aria-pressed', String(isSelected));
      });

      if (selected && selectedName) {
        selected.hidden = !name;
        selectedName.textContent = name || '';
      }
    };

    const select = (name) => {
      const session = write({ ...read(), grass: name });
      render(name);
      window.LSLawnProfile = session;
      window.dispatchEvent(new CustomEvent('ls:lawn-profile', { detail: session }));
    };

    render(read().grass || '');
    cards.forEach((card) => card.addEventListener('click', () => select(card.dataset.lawnName)));
  };

  document.querySelectorAll('[data-soil-lawns]').forEach(initialize);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target.querySelector?.('[data-soil-lawns]')));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ls-soil-temperature-lookup"] && !Shopify.designMode) return;
  try {
    
(() => {
  const root = document.querySelector('[data-soil-lookup]');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';

  const $ = (selector) => root.querySelector(selector);
  const zipInput = $('[data-soil-zip]');
  const submitButton = $('[data-soil-submit]');
  const submitLabel = submitButton.textContent;
  const locationText = $('[data-soil-location]');
  const errorText = $('[data-soil-error]');
  const result = $('[data-soil-result]');
  const context = $('[data-soil-context]');
  const snapshot = $('[data-soil-snapshot]');
  const snapshotGrid = $('[data-soil-snapshot-grid]');
  const source = $('[data-soil-source]');
  const normalizeZip = (value) => String(value || '').replace(/\D/g, '').slice(0, 5);

  const rules = JSON.parse($('[data-soil-timing-rules]').textContent || '[]');
  function buildTimingSnapshot(soil) {
    const timing = window.LSSoilTiming;
    const month = new Date().getMonth() + 1;
    const cards = rules.filter(rule => rule.enabled !== false && timing.seasonMatches(rule.season, month))
      .sort((a,b) => Number(a.sortOrder || 0)-Number(b.sortOrder || 0))
      .map(rule => ({label: rule.name, status: timing.evaluateRule(rule, Number(soil.average))}))
      .filter(card => card.status);

    snapshotGrid.replaceChildren(...cards.map((card) => {
      const item = document.createElement('div');
      item.className = 'soil-lookup__timing-item';
      const heading = document.createElement('strong');
      heading.textContent = card.label;
      const value = document.createElement('span');
      const greenStatuses = new Set(['Excellent Conditions', 'Good Timing']);
      value.className = greenStatuses.has(card.status) ? 'soil-lookup__timing-status soil-lookup__timing-status--ideal' : 'soil-lookup__timing-status';
      value.textContent = card.status;
      item.append(heading, value);
      return item;
    }));
    snapshot.hidden = cards.length === 0;
  }

  const geocodeZip = window.LSSoilTemperature.geocodeZip;

  async function load(location) {
    locationText.textContent = `${[location.city, location.state].filter(Boolean).join(', ')} · ${location.zip}`;
    const soil = await window.LSSoilTemperature.loadForLocation(location);
    $('[data-soil-current]').textContent = Math.round(soil.current);
    $('[data-soil-average]').textContent = Math.round(soil.average);
    $('[data-soil-trend]').textContent = soil.trend;
    const difference = soil.average - soil.previousAverage;
    const direction = difference > 0.4 ? 'warmer' : difference < -0.4 ? 'cooler' : 'about the same as';
    $('[data-soil-comparison]').textContent = direction === 'about the same as'
      ? 'Recent comparison: the 5-day average is about the same as the previous 5 days.'
      : `Recent comparison: the 5-day average is ${Math.abs(difference).toFixed(1)}°F ${direction} than the previous 5 days.`;
    result.hidden = false;
    context.hidden = false;
    source.hidden = false;
    buildTimingSnapshot(soil);
    localStorage.setItem('ls-soil-location-v1', JSON.stringify(location));
    window.LSSoilData = { ...soil, location };
    window.dispatchEvent(new CustomEvent('ls:soil-data', { detail: window.LSSoilData }));
  }

  async function run(postalCode) {
    submitButton.disabled = true;
    submitButton.setAttribute('aria-busy', 'true');
    submitButton.textContent = 'Checking…';

    try {
      errorText.hidden = true;
      await load(await geocodeZip(postalCode));
    } catch (error) {
      errorText.textContent = error.message;
      errorText.hidden = false;
    } finally {
      submitButton.disabled = false;
      submitButton.removeAttribute('aria-busy');
      submitButton.textContent = submitLabel;
    }
  }

  $('[data-soil-form]').addEventListener('submit', (event) => {
    event.preventDefault();
    const postalCode = normalizeZip(zipInput.value);
    zipInput.value = postalCode;
    if (postalCode.length === 5) run(postalCode);
  });

  (async () => {
    try {
      const saved = JSON.parse(localStorage.getItem('ls-soil-location-v1') || 'null');
      if (saved?.zip) {
        zipInput.value = saved.zip;
        return load(saved);
      }
      const detected = await fetch('https://api.bigdatacloud.net/data/reverse-geocode-client?localityLanguage=en').then((response) => response.json());
      const postalCode = normalizeZip(detected.postcode);
      if (String(detected.countryCode).toUpperCase() !== 'US' || postalCode.length !== 5) throw new Error();
      zipInput.value = postalCode;
      await run(postalCode);
    } catch (error) {
      locationText.textContent = 'Enter your ZIP code to check local soil temperature.';
    }
  })();
})();

  } catch(e) { console.error(e); }
})();
})();
